import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000,
});

// Request interceptor - attach token from localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - only log errors, defer logout to AuthContext's global interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      console.warn('[api] Network error or timeout - not logging out');
    }
    return Promise.reject(error);
  }
);

export default api;
